import {
  CheckMetadata,
  createSimpleCheckMetadataArray,
} from 'dashboard/components/ChecksTable/computeCheckMetadata';
import {
  DocumentPdfEditorDetection,
  DocumentPdfModificationDetection,
} from 'dashboard/models/check';

export const computeDocumentPdfEditorDetectionMetadata = (
  check: DocumentPdfEditorDetection | DocumentPdfModificationDetection,
): CheckMetadata => {
  if (check.reasons && check.reasons.length > 0 && check.metadata) {
    return {
      metadata: createSimpleCheckMetadataArray([
        {
          label: 'Risk Level',
          value: check.metadata['risk-level'] ? check.metadata['risk-level'].toUpperCase() : '-',
        },
        {
          label: 'Detected Editor',
          value: check.metadata['detected-pdf-editor'] || '-',
        },
      ]),
      hideIfVerificationPassed: true,
    };
  }

  return {
    metadata: [],
    hideIfVerificationPassed: true,
  };
};
